/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { assign, dispatchK, observe } from 'sdi/shape/functions';
import {
    viewEventsFactory,
    scaleEventsFactory,
    defaultInteraction,
    trackerEventsFactory,
} from 'sdi/map';
import { Feature, ILayerInfo } from 'sdi/source';
import { onSelectionChange } from 'embed/src/components/fancy';
import { getInteraction } from '../queries/map';

export const scalelineEvents = scaleEventsFactory(dispatchK('port/map/scale'));
export const viewEvents = viewEventsFactory(dispatchK('port/map/view'));

export const setZoom = (zoom: number) =>
    viewEvents.updateMapView({
        dirty: 'geo',
        zoom,
    });

export const dispatchView = dispatchK('port/map/view');
export const setInteraction = dispatchK('port/map/interaction');
export const assignLayerInfoList = (layers: ILayerInfo[]) =>
    assign('data/layerinfo-list', layers);

export const zoomToFeatures = (features: Feature[]) =>
    viewEvents.updateMapView({
        dirty: 'geo/feature',
        features,
    });

export const startMark = () =>
    setInteraction(s => {
        if (s.label === 'mark') {
            return { ...s, state: { ...s.state, started: true } };
        }
        return s;
    });

export const endMark = () => setInteraction(() => defaultInteraction());

export const trackerEvents = trackerEventsFactory(
    setInteraction,
    getInteraction,
);

export const startTracker = () => {
    assign('port/map/gps-tracker-active', true);
    trackerEvents.startTrack();
};

export const stopTracker = () => {
    assign('port/map/gps-tracker-active', false);
    trackerEvents.stopTrack();
};

// observe('app/selected-features', onSelectionChange);
observe('port/map/view', onSelectionChange);
